import { useEffect, useState } from "react";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import BusinessMenu from "./BusinessMenu";
import API_URL from "../../api/API";
import Sidebar from "../../components/Sidebar";
import RecentActivityRow from "../../components/recentactivity/RecentActivityRow";

const PAGE_SIZE = 20;

const RecentActivityList = () => {
  const { business } = useBusinessAuthContext();

  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  const fetchActivities = async (pageNumber = 1) => {
    try {
      setLoading(true);

      const res = await fetch(
        `${API_URL.BUSINESS_GET_RECENT_ACTIVITY}?page=${pageNumber}&limit=${PAGE_SIZE}`,
        {
          headers: {
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,
            "x-frontend-url": window.location.pathname,
          },
        }
      );

      const data = await res.json();

      if (data.success) {
        setActivities(data.activities || []);
        setPagination(data.pagination);
      }

    } catch (err) {
      console.error("Failed to load recent activity:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (business) {
      fetchActivities(page);
    }
  }, [business, page]);

  
  if (loading) {
    return (
      <div className="h-screen flex flex-row bg-background">
        <Sidebar />
        <div className="flex-1 overflow-auto py-9">
          <div className="max-w-6xl mx-auto px-6">
            Loading activity...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-row bg-background">
        
      <Sidebar />

        <div className="flex-1 h-auto overflow-auto py-9 transition">
            <div className="w-full max-w-4xl mx-auto px-4 md:px-6">

            <div className="mb-6">
                <h1 className="text-2xl font-semibold">
                Recent Activity
                </h1>

                <p className="text-sm text-gray-500">
                View activity across your business.
                </p>
            </div>

            <div className="bg-white border border-stroked rounded-2xl overflow-hidden">

                {activities.length === 0 ? (
                <div className="p-8 text-center text-gray-500">
                    No activity found.
                </div>
                ) : (
                <div>

                    {activities.map((activity, index) => (
                      <RecentActivityRow
                        key={activity._id}
                        activity={activity}
                        isLast={index === activities.length - 1}
                      />
                    ))}
                    
                </div>
                )}

            </div>


            {/* Pagination */}
            {pagination && pagination.totalPages > 1 && (
                <div className="flex items-center justify-between mt-6">

                <button
                    disabled={!pagination.hasPreviousPage}
                    onClick={() => setPage((p) => p - 1)}
                    className="px-4 py-2 border rounded-lg disabled:opacity-40"
                >
                    Previous
                </button>

                <span className="text-sm text-gray-500">
                    Page {pagination.page} of {pagination.totalPages}
                </span>

                <button
                    disabled={!pagination.hasNextPage}
                    onClick={() => setPage((p) => p + 1)}
                    className="px-4 py-2 border rounded-lg disabled:opacity-40"
                >
                    Next
                </button>

                </div>
            )}

            </div>
        </div>

    </div>
  );
};

export default RecentActivityList;